export default __webpack_public_path__ + "static/media/sketchbook.f9dbd726.webp";